import { MenuItem as MenuItemMUI, styled } from '@mui/material'

export const MenuItem = styled(MenuItemMUI)(() => ({
  display: 'flex',
  fontSize: 14,
  color: '#646464',
  gap: '16px',
  paddingTop: '6px',
  paddingBottom: '6px',
  paddingLeft: '12px',
  borderRadius: '6px'
}))

export const MenuItemsWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 200
}))
